/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createInvestmentEntity} from '../api'

export const useMutationCreateInvestmentEntity = createReactQueryMutationHook('createInvestmentEntity', createInvestmentEntity)
